import { Node } from '@tiptap/core';

export const InlineDocument = Node.create({
	name: 'doc',
	topNode: true,

	content: 'inline*',

	parseHTML() {
		return [{ tag: 'p' }];
	},

	renderHTML({ HTMLAttributes }) {
		return ['p', HTMLAttributes, 0];
	},
});
